/**
 * package: com.inq.net
 * class: URLLoader
 * @extends com.inq.events.EventDispatcher 
 * @constructor
 */
com.inq.net.URLLoader = function(customerID, timeout) {
	com.inq.events.EventDispatcher.call(this);
	this.index = 0;
	this.storageKey = "";
	this.data = "";
    this.responseStatus = 0;
    this.responseHeaderCacheControl = "";
	this.bytesLoaded = 0;
	this.timeout = timeout || 0;
	this.setCustomerID(customerID);
};
$hxClasses.extend(com.inq.events.EventDispatcher, com.inq.net.URLLoader, "com.inq.net.URLLoader");

/**
 * Sets customerID as request parameter
 * @param {String} customerID
 */
com.inq.net.URLLoader.prototype.setCustomerID = function(customerID) {
	this.customerIDAsFirstParamExpression = customerID ? "?" + com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.CUSTOMER_ID_PARAM + customerID : "";
};

/**
 * Creates WatchDog for current URLLoader.
 * @param {function} errorCallback - function for WatchDog in case the timeout works
 * @param {number} timeout - timeout in milliseconds
 * @param {string=} errorCallbackName - name of function
 */
com.inq.net.URLLoader.prototype.addWatchDog = function (errorCallback, timeout, errorCallbackName) {
	/** @type {com.inq.net.WatchDog} */
	this.watchDog = new com.inq.net.WatchDog(errorCallback, timeout, errorCallbackName);
};

/**
 * getContext - get the context from the array and remove it.
 * We now remove the item from the array by using the splice method.
 * This actually removes the item and we do not have to search for empty slots in registerContext above.
 * Removing the item makes a smaller array, and speeds up the finding of the requested item.
 *
 * @private
 * @static
 * @param {string}  UrlIndex
 * @return {?com.inq.net.URLLoader} - context (instance of URLLoader) or null
 */
com.inq.net.URLLoader.getContext = function(UrlIndex) {
	/** @type {number} */
	var idxContext = com.inq.net.URLLoader.indexOfContext(UrlIndex);
	if (idxContext != -1) {
		return com.inq.net.URLLoader.loadingArray.splice(idxContext, 1)[0].Context;
	} else {
		return null;
	}
};

/**
 * _httpRequestHandler
 *
 * @private
 * @static
 * @param {string} id
 * @param {string} data
 * @param {(number|string)} status - response status
 * @param {string} responseHeaderCacheControl - Cache-Control value of the response header
 * @param {object} context - needed only for logging
 *
 * @return {void}
 */
com.inq.net.URLLoader._httpRequestHandler = function (id, data, status, responseHeaderCacheControl, context) {
	/** @type {com.inq.net.URLLoader} */
	var instance = com.inq.net.URLLoader.getContext(id);

	if (instance === null) {
		com.inq.flash.client.control.FlashPeer.logWarningToServer(
			"Instance is null. Arguments are " + JSON.stringify(arguments)
		);

		return;
	}

    instance.responseStatus = status;
    instance.responseHeaderCacheControl = responseHeaderCacheControl;
    instance.data = data;
    instance.bytesLoaded = data && data.length ? data.length : 0;
    /*  fire the complete event */
    // Status 12029 for IE7 means ERROR_INTERNET_CANNOT_CONNECT - The attempt to connect to the server failed.
    if (status == 0 || (com.inq.net.URLLoader.isIE7 && status == 12029)) {
        // network error likely, force to retry
		instance.fireEvent(com.inq.events.Event.NETWORK_ERROR);
	} else if (status == 400) {
		instance.fireEvent(com.inq.events.Event.BAD_REQUEST);
    } else if (status == 401) {
        instance.fireEvent(com.inq.events.Event.UNAUTHORIZED);
	} else if (status == 502) {
		instance.fireEvent(com.inq.events.Event.BAD_GATEAWAY);
	} else if (status == 503) {
		instance.fireEvent(com.inq.events.Event.SERVICE_UNAVAILABLE);
	} else {
		instance.fireEvent(com.inq.events.Event.COMPLETE);
	}
};

/**
 * Callback function to handle error response as result of cross-domain request.
 *
 * @param {Object} context - error which happened on transport level
 * @return {void}
 */
com.inq.net.URLLoader.prototype.errorHandler = function (context) {
	if (context) {
		this.fireEvent(com.inq.events.Event.NETWORK_ERROR);
		com.inq.flash.client.control.FlashPeer.logErrorToServer("URLLoader.errorHandler. " + context.name + ": " + context.message);
	} else {
		com.inq.flash.client.control.FlashPeer.logWarningToServer(
			"URLLoader.errorHandler. Context is absent for " + this.storageKey
		);
	}
};

/**
 * Callback function to handle response as result of cross-domain request.
 *
 * @public
 * @param {Object} context data, which should be loaded
 * @return {void}
 */
com.inq.net.URLLoader.prototype.loadComplete = function (context) {
	if (context) {
		com.inq.net.URLLoader._httpRequestHandler(context.id, context.data, context["responseStatus"], context["responseHeaderCacheControl"], context);
	} else {
		com.inq.flash.client.control.FlashPeer.logWarningToServer(
			"URLLoader.loadComplete. Context is absent for " + this.storageKey
		);
	}
};

/**
 * cancelLoad
 * Cancel latest loading process.
 *
 * @todo to make the property "lastGetMsg" a private for instance of URLLoader, to cancel each of request if they are several
 *
 * @public
 * @this com.inq.net.URLLoader
 * @return {void}
 */
com.inq.net.URLLoader.prototype.cancelLoad = function() {
	if (com.inq.net.URLLoader.lastGetMsg) {
		var serverPath = com.inq.net.URLLoader.lastGetMsg.url;
		var lastMessageId = com.inq.net.URLLoader.lastGetMsg.id;

		this.send(serverPath, ["ABORT", lastMessageId], lastMessageId);

		this.watchDog.stop();
	}
};

/**
 * Sends request without postToServer for chat router and if useCorsRequestsToTS is true
 *
 * For other components sends request through postToServer.
 *
 * @param {string} serverPath - request url
 * @param {Array} request - request parameters
 * @param {string} id - request id
 * @param {Object=} context - request context
 * @param {boolean=} useCorsRequestsToTS - should requests to TS sent without iframe
 */
com.inq.net.URLLoader.prototype.send = function (serverPath, request, id, context, useCorsRequestsToTS) {
	var chatrouterURL = com.inq.flash.client.control.FlashVars.getSubmitURL();
	if (serverPath.startsWith(chatrouterURL) || useCorsRequestsToTS) {
		com.inq.flash.client.control.FlashPeer.sendRequestToServer(serverPath, request, id, context);
	} else {
		com.inq.flash.client.control.FlashPeer.postRequestToIframeProxy(serverPath, request, id, context);
	}
};

/**
 * loadByPosting - perform the load request via a post to a iframe-proxy
 *
 * @private
 * @this com.inq.net.URLLoader
 * @param {string}  reqUrl - the url and path with params to receive the request
 * @param {string}  id - the unique ID of request
 * @param {boolean} sendPost - flag of a sending the request by POST method (if "true" then "POST")
 * @param {number=} protectionId - customer protection ID
 * @return {void}
 */
com.inq.net.URLLoader.prototype.loadByPosting = function (reqUrl, id, sendPost, protectionId) {
    /*
     * The hosted file is the file hosted for us by our client
     * It is used to communicate back from an iframe in a different domain
     * It also hosts the IJSF, so getting the current window location gives us
     *   the hosted file
     */
    com.inq.net.URLLoader._hostedFile = window.location.protocol + "//" + (window.location.host + window.location.pathname);

	/** @type {Array} */
	var parts = reqUrl.split("?");
    var dest = parts[0];
    /* In order to fix an issue when one customer sends requests to different CR instances
     we need to send customerID in all requests from CI.
     And Load Balancer should route requests with specific customerID to the same CR instance.
     For convenience we send this parameter in URL for both GET and POST requests.*/
    var destURL;
    var data;
    if (sendPost || reqUrl.length > com.inq.net.URLLoader.MAXIMUM_IE_URL_LENGTH) {
        // POST method
        destURL = dest + this.customerIDAsFirstParamExpression;
        data = encodeURIComponent(parts[1]);
    } else {
        // GET
        if (this.customerIDAsFirstParamExpression) {
            destURL = dest + this.customerIDAsFirstParamExpression;
            if (parts[1]) {
                destURL += "&" + parts[1];
            }
        } else {
            destURL = reqUrl;
        }
        data = "";
        // store the last get message ID
        if (destURL.indexOf(com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MESSAGE_BASE_URL) > -1) com.inq.net.URLLoader.lastGetMsg = {id: id, url: destURL};
    }

    // storing storage to fetch an appropriate iframe later
    this.storageKey = destURL;
	// We will ask the proxy iframe to perform the post on our behalf
    var context = {};
	context["callbackFun"] = this.loadComplete.bind(this);
	context["callbackFunErr"] = this.errorHandler.bind(this);

	var tagServerBaseURL = com.inq.flash.client.control.FlashVars.getValue("tagServerBaseURL");
	var sendDataToTSWithoutIframe = com.inq.flash.client.control.FlashPeer.getFlagSendDataToTSWithoutIframe();
	var useCorsRequestsToTS = sendDataToTSWithoutIframe && reqUrl.startsWith(tagServerBaseURL);
	var command = "POSTCHAT";

	if (useCorsRequestsToTS) {
		command = "POSTASYNC";
	}

	/*
	 * isWebExternalVALink is set in ApplicationController, and is used to make a sync XHR
	 * post request before redirecting user to a different page.
	 */
	var isWebExternalVALink = com.inq.flash.client.control.ApplicationController.isWebExternalVALink;

	if (isWebExternalVALink) {
		command = "POSTSYNC";
		com.inq.flash.client.control.ApplicationController.isWebExternalVALink = false;
	}

	var request = [command, id, "", com.inq.net.URLLoader._hostedFile, destURL, data, this.timeout, protectionId];
	this.send(destURL, request, id, context, useCorsRequestsToTS);
};

/**
 * load
 *
 * @public
 * @this com.inq.net.URLLoader
 * @param {com.inq.net.URLRequest} request
 * @param {string=} sendKey - the key for "send" messages, optional
 * @param {boolean=} sendPost - flag of a sending the request by POST method (if "true" then "POST"), optional
 * @param {number=} protectionId - customer protection ID
 * @return {void}
 */
com.inq.net.URLLoader.prototype.load = function (request, sendKey, sendPost, protectionId) {
	if (this.watchDog) {
		this.watchDog.restart();
	}
	this.data = "";
	this.index = ++com.inq.net.URLLoader.seq;
	this.key = (sendKey ? sendKey : this.index) + "";
	this.registerContext(this.key);
	this.loadByPosting(request.url, this.key, sendPost, protectionId);
};

/**
 * fireEvent
 *
 * private function fireEvent(eventName:String):Bool
 * @private
 * @this com.inq.net.URLLoader
 * @param {string}  eventName 
 * @return {void}
 */
com.inq.net.URLLoader.prototype.fireEvent = function(eventName) {
	/** @type {com.inq.events.Event} */
	var ev = new com.inq.events.Event(eventName);
	ev.currentTarget = this;
	ev.target = this;

	if (!this.hasEventListener(eventName)) {
		haxe.Log.trace("function is not defined for Event.COMPLETE",{ fileName : "URLLoader.hx", lineNumber : 309, className : "com.inq.net.URLLoader", methodName : "fireEvent"});
	}

	try {
		this.dispatchEvent(ev);
	} catch(e) {
		var message = "";
		var stack = "";

		if (js.Boot.__instanceof(e, Error) || e.stack) {
			stack	= e.stack;
			message = e.message;
		} else {
			stack = new Error().stack;

			if (typeof e === "string") {
				message = e;
			}
		}

		if (!message) {
			message = "unavailable";
		}

		var module = js.Boot.__instanceof(this.constructor.__name__, Array)
			? this.constructor.__name__.join(".")
			: this.constructor.name;

		haxe.Log.trace("Could not fire event in " + module + ", reason: " + message + "\nStackTrace:" + stack, {
			fileName: "URLLoader.hx",
			lineNumber: 345,
			className: "com.inq.net.URLLoader",
			methodName: "fireEvent",
			customParams: [e]
		});

		com.inq.flash.client.control.FlashPeer.logError("URLLoader.fireEvent could not fire " + eventName + " event in " + module + ", reason: ", e);
	}

	return false;
};


/**
 * registerContext - register the context (URLLoader instace) via a key if not already there, so that we can
 * retrieve it from a static.
 *
 * @private
 * @this com.inq.net.URLLoader
 * @param {string}  Url -  acting as a key
 * @return {void}
 */
com.inq.net.URLLoader.prototype.registerContext = function(Url) {
    if (com.inq.net.URLLoader.indexOfContext(Url) == -1) {
		com.inq.net.URLLoader.loadingArray.push({UrlIndex: Url, Context: this});
    }
};

/**
 * indexOfContext - returns the index of the existent context in list or -1 if context is absent.
 *
 * @private
 * @static
 * @param {string} key
 * @return {number} index of context or -1
 */
com.inq.net.URLLoader.indexOfContext = function(key) {
	for (var i = 0; i < com.inq.net.URLLoader.loadingArray.length; i++) {
		if (key == com.inq.net.URLLoader.loadingArray[i].UrlIndex) {
			return i;
		}
	}
	return -1;
};

/** @private @type {string} */
com.inq.net.URLLoader.prototype.key = null;
/** @type {com.inq.net.URLLoader} */
com.inq.net.URLLoader.prototype.__class__ = com.inq.net.URLLoader;
/** @private @type {number} */
com.inq.net.URLLoader.MAXIMUM_IE_URL_LENGTH = 2083;

/** @private @type {Array} */
com.inq.net.URLLoader.loadingArray = new Array();

/** @private @type {number} */
com.inq.net.URLLoader.seq = 0;

/** @private @type {number} */
com.inq.net.URLLoader.lastGetMsg = null;

/** @private @type {string} */
com.inq.net.URLLoader._hostedFile = "";

/** @private @type {boolean} */
com.inq.net.URLLoader.isIE7 = window.navigator.appVersion.indexOf("MSIE 7.") != -1;
